<template>
  <section class="page_not_found">
    <header-logged-out type="404" />
    <v-container fill-height>
      <v-row
        justify="center"
        align="center"
        class="flex-column fill-height flex-nowrap"
      >
        <img
          :src="`${bucketUrl}/error/page_image_404.svg`"
          alt="404 page image"
        />
        <h1 class="display-3 font-weight-bold">Oops!</h1>
        <p class="headline font-weight-medium">
          We can't seem to find the<br />
          page you are looking for
        </p>
        <v-btn color="primary" href="/teacher/login">
          Click here to go to login screen
        </v-btn>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import HeaderLoggedOut from '@/modules/auth/views/HeaderLoggedOut'
import { mapState } from 'vuex'

export default {
  name: 'PageNotFound',
  components: {
    HeaderLoggedOut
  },
  computed: {
    ...mapState(['bucketUrl'])
  }
}
</script>

<style lang="scss" scoped>
.page_not_found {
  img {
    width: 70%;
  }

  h1,
  p {
    color: var(--v-primary-base);
  }
}
</style>
